const ga = (...args: any) => {
  if (
    typeof window !== 'undefined' &&
    typeof (window as any).ga === 'function'
  ) {
    ;(window as any).ga(...args)
  }
}

export default ga
